import { useEffect, useState } from 'react';
import {HTTP_URL_GET_IP} from "../../constants/apiSuffix";



export default function useBrowserInfoAndIP() {
  const [browserInfo, setBrowserInfo] = useState(null);
  const [ipAddress, setIpAddress] = useState(null);

  useEffect(() => {
    const info = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      appVersion: navigator.appVersion,
      vendor: navigator.vendor,
    };
    setBrowserInfo(info);

    fetch(HTTP_URL_GET_IP)
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch((err) => console.error('No IP:', err));
  }, []);

  return { browserInfo, ipAddress };
}
